export default function translate(i18n, propriete) {
  if (propriete === 'etat') return i18n.t('addEditMoisComptable.information.etat');
  if (propriete === 'dateFin') return i18n.t('addEditMoisComptable.information.dateFin');
  if (propriete === 'dateDebut') return i18n.t('addEditMoisComptable.information.dateDebut');
  if (propriete === 'exerciceComptableId') return i18n.t('addEditMoisComptable.information.exerciceComptable');
  return propriete;
}
